import { ModalType, AuthUserType } from "../../Actions/Types"
import { Reducer } from "redux"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import { ModalView, ModalViewName } from "../../Models/Client/Modal"
import { AuthAction } from "../Auth"

export interface ModalState {
    view?: ModalView
}

interface ModalOpenAction {
    type: ModalType.openModalView
    payload: ModalView
}

interface ModalCloseAction {
    type: ModalType.closeModalView
}

export type ModalAction = ModalOpenAction | ModalCloseAction

const initialState: ModalState = {
    view: undefined
}

export const ModalReducer: Reducer<
    ModalState,
    ModalAction | RouterAction | AuthAction
> = (state = initialState, action): ModalState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            const { search } = action.payload.location
            const params = new URLSearchParams(search)
            const showNewsletterSubscription =
                params.get("intent") === "newsletter"

            return showNewsletterSubscription
                ? {
                      ...state,
                      view: { type: ModalViewName.newsletterSubscription }
                  }
                : initialState
        case ModalType.openModalView:
            return {
                ...state,
                view: action.payload
            }
        case ModalType.closeModalView:
            return {
                ...state,
                view: undefined
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
